import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/main.css';

const Navigation: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const toggleServices = () => {
    setIsServicesOpen(!isServicesOpen);
  };

  const closeMenus = () => {
    setIsOpen(false);
    setIsServicesOpen(false);
  };

  return (
    <nav className="nav">
      <div className="nav-container">
        <div className="nav-logo">
          <Link to="/">Pawel Piwosz</Link>
        </div>
        <div className="nav-toggle" onClick={toggleMenu}>
          <i className={`fa ${isOpen ? 'fa-times' : 'fa-bars'}`}></i>
        </div>
        <ul className={`nav-list ${isOpen ? 'open' : ''}`}>
          <li className="nav-item dropdown">
            <div className="nav-services-container">
              <Link to="/professional-services" className="nav-services" onClick={closeMenus}>
                Professional Services
              </Link>
              <button 
                className="services-toggle" 
                onClick={toggleServices}
                aria-label="Toggle services menu"
              >
                <i className={`fa ${isServicesOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
              </button>
            </div>
            <ul className={`services-submenu ${isServicesOpen ? 'open' : ''}`}>
              <li><Link to="/trainings" onClick={closeMenus}>Trainings</Link></li>
              <li><Link to="/assessment" onClick={closeMenus}>Assessment</Link></li>
              <li><Link to="/cloud-consulting" onClick={closeMenus}>Cloud Consulting</Link></li>
              <li><Link to="/iac-consulting" onClick={closeMenus}>IaC Consulting</Link></li>
              <li><Link to="/cicd-consulting" onClick={closeMenus}>CI/CD Consulting</Link></li>
            </ul>
          </li>
          <li><Link to="/" onClick={closeMenus}>Home</Link></li>
          <li><Link to="/about" onClick={closeMenus}>About</Link></li>
          <li><Link to="/conferences" onClick={closeMenus}>Conferences</Link></li>
          <li><Link to="/community" onClick={closeMenus}>Community</Link></li>
          <li><Link to="/mentor" onClick={closeMenus}>Mentor</Link></li>
          <li><Link to="/organizer" onClick={closeMenus}>Organizer</Link></li>
          <li><Link to="/publications" onClick={closeMenus}>Publications</Link></li>
          <li><Link to="/projects" onClick={closeMenus}>Projects</Link></li>
          <li><Link to="/contact" onClick={closeMenus}>Contact</Link></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;